import { render, staticRenderFns } from "./AdminPrices.vue?vue&type=template&id=6c7f9c4e&scoped=true"
import script from "./AdminPrices.vue?vue&type=script&lang=js"
export * from "./AdminPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7f9c4e",
  null
  
)

export default component.exports